import { render, staticRenderFns } from "./LeftTree.vue?vue&type=template&id=4c0ec126&scoped=true&"
import script from "./LeftTree.vue?vue&type=script&lang=ts&"
export * from "./LeftTree.vue?vue&type=script&lang=ts&"
import style0 from "./LeftTree.vue?vue&type=style&index=0&id=4c0ec126&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ec126",
  null
  
)

export default component.exports